/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    FOUNDER: 'founder',
    ADMIN: 'admin',
    LECTURER: 'lecturer',
};
